var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.28571 36H41.7143C42.4244 36 43 35.7214 43 35C43 34.2786 42.4244 34 41.7143 34H8.28571C7.5756 34 7 34.2786 7 35C7 35.7214 7.5756 36 8.28571 36Z",
    fill: "#5FD0FB",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28571 16H41.7143C42.4244 16 43 15.7214 43 15C43 14.2786 42.4244 14 41.7143 14H8.28571C7.5756 14 7 14.2786 7 15C7 15.7214 7.5756 16 8.28571 16Z",
    fill: "#5FD0FB",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28571 26H41.7143C42.4244 26 43 25.7214 43 25C43 24.2786 42.4244 24 41.7143 24H8.28571C7.5756 24 7 24.2786 7 25C7 25.7214 7.5756 26 8.28571 26Z",
    fill: "#5FD0FB",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28571 35H40.7143C41.4244 35 42 34.7214 42 34C42 33.2786 41.4244 33 40.7143 33H7.28571C6.5756 33 6 33.2786 6 34C6 34.7214 6.5756 35 7.28571 35Z",
    fill: "#011E29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28571 15H40.7143C41.4244 15 42 14.7214 42 14C42 13.2786 41.4244 13 40.7143 13H7.28571C6.5756 13 6 13.2786 6 14C6 14.7214 6.5756 15 7.28571 15Z",
    fill: "#011E29"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28571 25H40.7143C41.4244 25 42 24.7214 42 24C42 23.2786 41.4244 23 40.7143 23H7.28571C6.5756 23 6 23.2786 6 24C6 24.7214 6.5756 25 7.28571 25Z",
    fill: "#011E29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.5ac822e9d4c9261c18a7aa4e266bb069.svg";
export { ForwardRef as ReactComponent };